'use client';

import { useEffect, useState } from 'react';
import { Article, CategoryWithCount } from '@/types/types';
import { DesktopSidebar } from './blog-desktop-sidebar';
import { MobileCategoryDrawer } from './blog-mobile-drawer';

interface CategorySidebarProps {
	categories: CategoryWithCount[];
	article?: Article;
}

export function BlogSidebar({ categories, article }: CategorySidebarProps) {
	const [searchQuery, setSearchQuery] = useState('');
	const [isExpanded, setIsExpanded] = useState(false);
	const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false);

	// Close drawer when clicking outside
	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			const drawer = document.getElementById('mobile-category-drawer');
			const button = document.getElementById('mobile-category-button');

			if (
				drawer &&
				button &&
				!drawer.contains(event.target as Node) &&
				!button.contains(event.target as Node) &&
				isMobileDrawerOpen
			) {
				setIsMobileDrawerOpen(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [isMobileDrawerOpen]);

	// Prevent body scroll when drawer is open
	useEffect(() => {
		if (isMobileDrawerOpen) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = 'auto';
		}

		return () => {
			document.body.style.overflow = 'auto';
		};
	}, [isMobileDrawerOpen]);

	return (
		<>
			{/* Mobile Components */}
			<MobileCategoryDrawer
				categories={categories}
				article={article}
				searchQuery={searchQuery}
				setSearchQuery={setSearchQuery}
				isMobileDrawerOpen={isMobileDrawerOpen}
				setIsMobileDrawerOpen={setIsMobileDrawerOpen}
			/>

			{/* Desktop Components */}
			<DesktopSidebar
				categories={categories}
				article={article}
				searchQuery={searchQuery}
				setSearchQuery={setSearchQuery}
				isExpanded={isExpanded}
				setIsExpanded={setIsExpanded}
			/>
		</>
	);
}
